import React, { useState } from 'react';
import { Box } from 'rebass';
import { Button } from '../../../components/styled/button';
import { DateField, TextareaField } from '../../../components/styled/forms';
import { ReactComponent as AddIcon } from '../../../icons/add.svg';
import { space } from '../../../theme';

export const SectionOption03AsPlanned: React.FC = () => {
  const [noteAdded, setNoteAdded] = useState<boolean>(false);

  return (
    <>
      <DateField name="dateOfService" label="Date delivered" />

      {noteAdded ? (
        <Box mt={space.two}>
          <TextareaField
            autoFocus={true}
            name="note"
            label="Note"
            data-testid="track-session-notes"
            onBlur={e => {
              if (e.target.value.trim() === '') {
                setNoteAdded(false);
              }
            }}
          />
        </Box>
      ) : (
        <Button
          mt={space.one}
          variant="text"
          icon={AddIcon}
          onClick={() => setNoteAdded(true)}
          minWidth={['auto', 'auto', 'auto']}
        >
          Add note (optional)
        </Button>
      )}
    </>
  );
};
